import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import projectJson from '../../../package.json';

const Copyright = (props) => {

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <Box sx={{alignItems: "center", backgroundColor: "#f9f9f9", display: "flex", flexDirection: "column", justifyContent: "center", p:1,}}>
      <Link href="https://www.cadsoft.com" target="_blank">
        <Box
          alt="Cadsoft Logo"
          component="img"
          loading="lazy"
          src={
            process.env.NODE_ENV === 'development' ? 
              "/assets/svg/logos/primary/cadsoft.svg" : 
              "/wp-content/themes/personal-architect/assets/svg/logos/primary/cadsoft.svg"
          }
          sx={{border: "solid 1px transparent", height: 44.6166, p: .5, width: 150,
            "&:hover": {
              border: "solid 1px #000000",
            },
          }}
        />
      </Link>
      <Typography fontSize={12}>© Cadsoft Corporation {currentYear}, All Rights Reserved. v{projectJson.version}</Typography>
    </Box>
  )
}

export default Copyright